import { create, useModal } from "@ebay/nice-modal-react";
import { WarningIcon } from "@phosphor-icons/react";
import { useState } from "react";

import { analyticsEvent } from "@up/analytics";
import { useGeoData, useTheme } from "@up/data";
import { Modal, ModalContent, Spinner } from "@up/ui";

import { markAsDismissed, markAsSuccess } from "../helpers";
import { Form } from "./Form";

/**
 * You must define `window.leadCaptureConfig.topics` if you want topic selection
 * otherwise the program selection will be shown.
 */
export const LeadCaptureSyllabusv1ModalGUOPVS = create(
  ({ modalID, trigger = "unknown" }: { modalID: string; trigger?: string }) => {
    const theme = useTheme();
    const modal = useModal();
    const geo = useGeoData();
    const [isSuccess, setIsSuccess] = useState(false);

    const closeModal = () => {
      markAsDismissed(modalID);
      modal.hide();
      setTimeout(() => {
        modal.remove();
      }, 100);
    };

    return (
      <Modal close={closeModal} visible={modal.visible}>
        <ModalContent
          Heading={(headingProps) => {
            return (
              <h2
                {...headingProps}
                className={theme.heading2Class}
                data-testid="lead-capture-heading"
              >
                {isSuccess
                  ? "Access Our Course Syllabi"
                  : `Want more information about the ${theme.partnerOnlineName}?`}
              </h2>
            );
          }}
        >
          <button
            className="absolute right-0 top-0 px-4 pb-1 pt-3 underline lg:pr-9 lg:pt-4"
            style={{ right: 0 }}
            onClick={closeModal}
          >
            close
          </button>

          {geo.isLoading ? (
            <div className="flex flex-col items-center gap-2 pt-6">
              <Spinner />
              Loading
            </div>
          ) : null}

          {geo.didError ? (
            <div className="flex flex-col items-center gap-2 pt-6 text-red-500">
              <WarningIcon size={32} weight="fill" color="#d00" />
              <span className="text-center">
                Something went wrong.
                <br />
                <button className="underline" onClick={closeModal}>
                  Close
                </button>
              </span>
            </div>
          ) : null}

          {geo.data ? (
            <Form
              close={closeModal}
              geoData={geo.data}
              modalId={modalID}
              onSuccess={() => {
                setIsSuccess(true);
                analyticsEvent({
                  event: "leadCaptureSuccess",
                  formID: modalID,
                  trigger,
                });
                markAsDismissed(modalID);
                markAsSuccess(modalID);
              }}
              topics={
                (window.leadCaptureConfig?.topics as string[]) ?? undefined
              }
              trigger={trigger}
            />
          ) : null}
        </ModalContent>
      </Modal>
    );
  },
);
